import { Input, Typography } from 'antd';
import { PhoneOutlined } from "@ant-design/icons";
import { useState, useEffect, useRef } from 'react';
import { _colors } from '../styles/themes';
import "../styles/phone-number-field.scss";

export const phoneNumberIsMatch = (phoneNumber) => /\(\d{3}\) \d{3}-\d{2}-\d{2}/g.test(phoneNumber);

const { Text } = Typography;

const PhoneNumberFieldPrefix = () => {
    return (
        <div>
            <PhoneOutlined style={{ color: _colors.grey2 }} />
            <Text className="phone-number-field__prefix__country-code">+7</Text>
        </div>
    );
}

// Номер телефона с маской ввода (800) 555-35-35
export const InputPhoneNumber = (props) => {

    // возвращает введенный номер по маске (800) 555-35-35
    const formValueByMask = (inputedPhoneNumber) => {
        if (inputedPhoneNumber) {

            const clearedValue = inputedPhoneNumber.replaceAll(/[^\d_]/g, '');

            let finalValue = '';

            for (let i = 0; i < clearedValue.length; i++) {
                if (i === 0)
                    finalValue += '(';
                else if (i === 3)
                    finalValue += ') ';
                else if (i === 6 || i === 8)
                    finalValue += '-';

                finalValue += clearedValue[i];
            }

            return finalValue;
        }

        return '';
    }

    const { onChange, value, ...otherProps } = props;

    const [editingValue, setEditingValue] = useState(value);

    // диапазон выделения текста в поле ввода. См. также "isSetSelectionByVariables"
    const [fieldSelectionRange, setFieldSelectionRange] = useState({ start: 0, end: 0 });

    // true - установить диапазон выделения по "fieldSelectionRange",
    // иначе - стандартная установка по "<элементУправления>.selectionStart" и "<элементУправления>.selectionEnd"
    const [isSetSelectionByVariables, setIsSetSelectionByVariables] = useState(false);

    const internalFieldId = crypto.randomUUID();

    useEffect(() => setEditingValue(formValueByMask(value)), [value]);

    useEffect(() => {
        if (isSetSelectionByVariables)
            document.getElementById(internalFieldId).dispatchEvent(new Event('onSelect'));
    }, [fieldSelectionRange]);

    const setFieldSelectionValues = (start, end) => {
        setFieldSelectionRange({
            start: start,
            end: end
        })
    }

    // Индекс выделения на основе текущего индекса выделения с учетом примененной маски номера телефона (см. описание элемента управления выше)
    const getSelectionPosition = (currentPosition) => {
        let newPosition = currentPosition;

        // позиция следующая за открывающей скобкой "("
        if (currentPosition === 0 || currentPosition === 1)
            newPosition = 2;

        else if (currentPosition === 4)
            newPosition = 6;

        // позиция следующая за закрывающей скобкой ")" и пробелом после её, т.е. за сочитанием символов ") "
        else if (currentPosition === 5)
            newPosition = 7;

        // позиция следующая за черточкой "-"
        else if (currentPosition === 10 || currentPosition === 13)
            newPosition = currentPosition + 1;

        return newPosition;
    }

    const handleInternalFieldChange = (eventArgs) => {
        let finalValue = formValueByMask(eventArgs.currentTarget.value);
        setEditingValue(finalValue);

        // после изменения "eventArgs.currentTarget.value" индексы выделения изменятся.
        // То есть, если меняется символ в начале строки, то выделение перекинет в конец
        const selectionStart = getSelectionPosition(eventArgs.currentTarget.selectionStart);
        const selectionEnd = eventArgs.currentTarget.selectionStart === eventArgs.currentTarget.selectionEnd
            ? selectionStart
            : getSelectionPosition(eventArgs.currentTarget.selectionEnd);

        eventArgs.currentTarget.value = finalValue;

        onChange(eventArgs);

        setIsSetSelectionByVariables(true);

        setFieldSelectionValues(selectionStart, selectionEnd);
    }

    const handleInternalFieldSelectionChange = (eventArgs) => {
        if (isSetSelectionByVariables) {
            eventArgs.currentTarget.setSelectionRange(fieldSelectionRange.start, fieldSelectionRange.end);
            setIsSetSelectionByVariables(false);
        }
        else {
            setFieldSelectionRange(
                eventArgs.currentTarget.selectionStart,
                eventArgs.currentTarget.selectionEnd
            );

            eventArgs.currentTarget.setSelectionRange(eventArgs.currentTarget.selectionStart, eventArgs.currentTarget.selectionEnd);
        }
    }

    return (
        <Input
            {...otherProps}
            id={internalFieldId}
            onChange={handleInternalFieldChange}
            onSelect={handleInternalFieldSelectionChange}
            value={editingValue}
            placeholder='(___) ___-__-__'
            prefix={<PhoneNumberFieldPrefix />}
            count={
                {
                    max: 15,
                    exceedFormatter: (txt, { max }) => txt.slice(0, max)
                }
            }
        />
    );
}